import React from 'react';
import root from 'window-or-global';
import {useLocation} from 'react-router-dom';

/**
 * Scroll to Top on update route
 * Scroll to Anchor (if exist) on page load / update
 */
const ScrollOnUpdate: React.FC = props => {
    const location = useLocation<{skipScroll?: boolean}>();

    React.useEffect(() => {
        if (location.state && location.state.skipScroll) {
            return;
        }

        const scrollToElement = async () => {
            if (!location.hash) {
                root.scrollTo(0, 0);
                return true;
            }

            setTimeout(() => {
                const id = location.hash.split('?')[0].replace('#', '');
                const element = root.document.getElementById(id);
                if (element) {
                    element.scrollIntoView();
                }
            }, 1000);

            return true;
        };

        scrollToElement().catch(err => {
            root.scrollTo(0, 0);
        });
    }, [location]);

    return <>{props.children}</>;
};

export default ScrollOnUpdate;
